import { render, staticRenderFns } from "./LanziFapiao.vue?vue&type=template&id=11776d88&scoped=true&"
import script from "./LanziFapiao.vue?vue&type=script&lang=js&"
export * from "./LanziFapiao.vue?vue&type=script&lang=js&"
import style0 from "./LanziFapiao.vue?vue&type=style&index=0&id=11776d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11776d88",
  null
  
)

export default component.exports